import {
  DamagedVehicleCorrectiveImageNameType,
  DamagedVehicleCorrectiveImageTabType,
} from '@/modules/adjusterReportModules/IncidentParticipants/types/images';
import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DamagedPointsIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/damagedPointsIcon.svg?react';
import IndividualDocumentsIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/individualDocumentsIcon.svg?react';
import VehicleImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/vehicleImageIcon.svg?react';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import CardButton from '@/common/components/cardButton/CardButton';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import getDamagedVehicleCorrectiveImagesFormTabsOptions from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImagesFormTabs/getDamagedVehicleCorrectiveImagesFormTabsOptions';
import CorrectiveImageModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/inquiredForm/components/modals/CorrectiveImageModal';
import useModal from '@/common/hooks/useModal';
import { FileTypeConst } from '@/common/types/Files.type';
export const InquiredFormTabs = ({
  typeRequest,
}: {
  typeRequest?: FileTypeConst;
}) => {
  const { id, damagedId } = useParams();
  const { closeModal, open, openModal } = useModal();
  const [type, setType] = useState<DamagedVehicleCorrectiveImageNameType>(
    DamagedVehicleCorrectiveImageNameType.documents,
  );
  const { data, isPending } = useQuery(
    getDamagedVehicleCorrectiveImagesFormTabsOptions(
      {
        damage_id: +damagedId!,
        id: +id!,
      },
      typeRequest,
    ),
  );

  return (
    <Box
      className={css({
        paddingTop: '2rem',
        width: '100%',
      })}
    >
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <>
          {data?.map((item) => (
            <CardButton
              key={item?.name}
              cardProps={{
                className: css({ marginY: '1rem' }),
                onClick: () => {
                  openModal();

                  setType(DamagedVehicleCorrectiveImageNameType[item?.name]);
                },
              }}
              hasArrow
              renderIcon={() => renderIcon(item?.name)}
              title={item?.fa_name}
            />
          ))}
        </>
      )}
      <CorrectiveImageModal
        open={open}
        closeModal={closeModal}
        type={type}
        requestType={typeRequest}
      />
    </Box>
  );
};

export default InquiredFormTabs;

const renderIcon = (tabName: DamagedVehicleCorrectiveImageTabType['name']) => {
  let tabIcon: Record<
    DamagedVehicleCorrectiveImageTabType['name'],
    React.JSX.Element
  > = {
    documents: <IndividualDocumentsIcon />,
    vehicle: <VehicleImageIcon />,
    damaged_parts: <DamagedPointsIcon />,
  };
  return tabIcon[tabName];
};
